import { Getters } from 'vuex-smart-module';
import ReportsState from './state';

export default class ReportsGetters extends Getters<ReportsState> {}
